<template>
  <div>
    <page-title icon="fa fa-leaf" main="Comercial" sub="Períodos Comerciais" :help="true" titleHelp="Ajuda - Períodos Comerciais"
    content="Página responsável pela listagem de Períodos Comerciais.
Para criação pressione o botão no canto superior direito 'Novo Período Comercial'.
Para alteração basta ir com o mouse em ações e clicar em Editar'.
">
      <template v-slot:actions>
        <base-button
          v-if="$can('create', 'commercials')"
          @click="newCommercial"
          type="neutral"
          class="ml-3"
          size="sm"
        >
          Novo Período Comercial
        </base-button>
      </template>
    </page-title>
    <div class="card mt-2" style="padding: 1rem">
      <div slot="header" class="align-items-center">
        <div class="col-sm-12 col-md-6">
          <h5 class="h3 mb-0">Filtros</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Configure quais dados deverão ser listados:
          </h6>
          <base-input group class="mb-0 col-4 mt-2" label="Período comercial">
            <input type="text" class="form-control" v-model="filter.name" placeholder="Informe o Período Comercial" />
            <div class="input-group-append">
              <base-button outline type="success" id="button-addon2" v-on:click="search">Pesquisar</base-button>
            </div>
          </base-input>
        </div>
      </div>
      <modal :show.sync="modals.modal0" class="col-12" id="commercial" @close="closeModal0">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Novo Período Comercial</h5>
        </template>
        <form role="form" @submit.prevent="reportAlert(save)">
          <div class="row justify-content-md-center">
            <div class="col-12 form-group">
              <label class="form-control-label">Descrição do Período Comercial <span class="text-danger">*</span> </label><br>
              <input
                type="text"
                class="form-control"
                placeholder="Nome da Duração do Período Comercial"
                v-model="commercial.name"
                aria-label="Nome da Duração do Período Comercial"
                @change="errors.name = null"
              />
              <div v-if="errors.name" class="invalid-feedback" style="display: block;">
                {{ errors.name }}
              </div>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Duração do Período Comercial <span class="text-danger">*</span> </label><br>
              <el-date-picker
                class="mobile-date-picker"
                v-model="commercialDateRange"
                type="daterange"
                :editable="false"
                range-separator="-"
                start-placeholder="Data início"
                end-placeholder="Data fim"
                unlink-panels
                @change="errors.initial_date = null; errors.final_date = null"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
              <div v-if="errors.initial_date || errors.final_date" class="invalid-feedback" style="display: block;">
                {{ errors.initial_date || errors.final_date }}
              </div>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Data Limite para Alteração <span class="text-danger">*</span> </label><br>
              <el-date-picker
                v-model="commercial.alteration_limit"
                prefix-icon="fa fa-calendar"
                :editable="false"
                @change="errors.alteration_limit = null"
                :picker-options="{disabledDate: validationDayDisabledDate}"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
              <div v-if="errors.alteration_limit" class="invalid-feedback" style="display: block;">
                {{ errors.alteration_limit }}
              </div>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Tabelas ERP</label><br>
              <multiselect
                v-model="selectedTables"
                label="desc_cta"
                track-by="tabe_cta"
                placeholder="Selecione uma opção"
                :limit="1"
                :limit-text="limitText"
                :options="tables_erp"
                :multiple="true"
                :loading="isLoadingDefaultTables"
                :close-on-select="false"
              />
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Copiar Período Comercial Anterior</label><br>
              <base-switch v-model="commercial.copy"  style="margin-bottom: 10px;"/>

              <div v-if="commercial.copy">
                <label class="form-control-label">Período Comercial <span class="text-danger">*</span></label><br>
                <multiselect
                  v-model="commercialsCopy"
                  :options="commercialPeriod"
                  :searchable="true"
                  track-by="id"
                  label="name"
                  placeholder="Selecione um período comercial"
                  @select="errorsBrands.commercial = null"
                />
                <div v-if="errorsBrands.commercial" class="invalid-feedback" style="display: block;">
                  {{ errorsBrands.commercial }}
                </div>
                <br>
                <label class="form-control-label">Marca Comercial <span class="text-danger">*</span></label><br>
                <multiselect
                  v-model="commercialbrands"
                  :options="brands"
                  :multiple="true"
                  :limit="1"
                  :limit-text="limitText"
                  :searchable="true"
                  :loading="isLoadingBrands"
                  track-by="id"
                  label="name"
                  placeholder="Selecione uma marca comercial"
                  @change="handleSelect"
                  @select="errorsBrands.brands = null"
                  :disabled="commercialsCopy.length === 0"
                >
                  <template slot="beforeList" class="">
                    <div @click="toggleSelectAll" :class="allSelected ? 'all-selected ' : 'multiple select-all-option'" :style="allSelected ? 'background-color: #e9ecef; color: #212529' : ''">
                      <span :style="allSelected ? 'font-weight: 700' : ''">{{ noneSelected ? 'selecionar todas' : (allSelected ? 'desmarcar todas' : 'selecionar todas') }}</span>
                    </div>
                  </template>
                </multiselect>
                <div v-if="errorsBrands.brands" class="invalid-feedback" style="display: block;">
                  {{ errorsBrands.brands }}
                </div>
              </div>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button type="secondary" class="mr-2" @click="closeModal0">Fechar</base-button>
          <base-button type="success" @click="reportAlert(save)" v-loading="loadingSaveCommercial">Salvar</base-button>
        </template>
      </modal>

      <modal :show.sync="modals.modal1" id="commercial-edit" @close="closeModal1">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">Editar Período Comercial</h5>
        </template> 
        <form role="form" @submit.prevent="reportAlert(editcommercial)">
          <div class="row justify-content-md-center">
            <div class="col-12 form-group">
              <label class="form-control-label">Descrição do Período Comercial</label><br>
              <input
                type="text"
                class="form-control"
                placeholder="Nome do Duração do Período Comercial"
                v-model="commercial.name"
                aria-label="Nome do Duração do Período Comercial"
                @change="errors.name = null"
              />
              <div v-if="errors.name" class="invalid-feedback" style="display: block;">
                {{ errors.name }}
              </div>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Duração do Período Comercial</label><br>
              <el-date-picker
                v-model="commercialDateRange"
                type="daterange"
                range-separator="-"
                start-placeholder="Data início"
                end-placeholder="Data fim"
                unlink-panels
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
              <div v-if="errors.initial_date || errors.final_date" class="invalid-feedback" style="display: block;">
                {{ errors.initial_date || errors.final_date }}
              </div>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Data Limite para Alteração</label><br>
              <el-date-picker
                v-model="commercial.alteration_limit"
                prefix-icon="fa fa-calendar"
                format="d 'de' MMMM 'de' yyyy">
              </el-date-picker>
              <div v-if="errors.alteration_limit" class="invalid-feedback" style="display: block;">
                {{ errors.alteration_limit }}
              </div>
            </div>
            <div class="col-12 form-group">
              <label class="form-control-label">Tabelas ERP</label><br>
              <multiselect
                v-model="commercial.commercial_table"
                label="desc_cta"
                track-by="tabe_cta"
                placeholder="Selecione uma opção"
                :limit="1"
                :limit-text="limitText"
                :options="tables_erp"
                :multiple="true"
                :loading="isLoadingDefaultTables"
                :close-on-select="false"
              />
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button type="secondary" @click="closeModal1">Fechar</base-button>
          <base-button type="success" @click="reportAlert(editcommercial)">Salvar</base-button>
        </template>
      </modal>

      <div class="border-0 card-header">
        <h3 class="mb-0">Períodos Comerciais:</h3>
      </div>

      <el-table
        v-loading="isLoading"
        :data="commercials"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        style="width: 100%;"
      >
        <el-table-column label="Status" prop="is_open" width="100px" v-slot="{ row }" sortable>
          <badge class="badge-dot mr-4" type v-if="row.is_open">
            <i class="bg-success"></i> Aberto
          </badge>
          <badge class="badge-dot mr-4" type v-else>
            <i class="bg-danger"></i> Fechado
          </badge>
        </el-table-column>
        <el-table-column
          label="Descrição"
          prop="name"
          sortable
          width="400px"
        />

        <el-table-column label="Data de inicio" prop="initial_date" v-slot="{ row }" sortable >
          {{row.initial_date | formatDate}}
        </el-table-column>
        <el-table-column label="Data de fim" prop="final_date" v-slot="{ row }" sortable >
          {{row.final_date | formatDate}}
        </el-table-column>
        <el-table-column label="Limite de Alteração" prop="alteration_limit" v-slot="{ row }" sortable>
          {{row.alteration_limit | formatDate}}
        </el-table-column>

        <el-table-column
          v-if="$can('update', 'commercials') || $can('destroy', 'commercials')"
          label="Ações"
          width="80px"
          prop="acoes"
          v-slot="{ row }"
        >
          <el-dropdown
            trigger="hover"
            class="dropdown"
            style="cursor: pointer;"
          >
            <span class="btn btn-sm btn-icon-only text-success">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <a v-if="$can('update', 'commercials')" class="dropdown-item" href="#" @click="edit(row)">Editar</a>
              <a v-if="$can('destroy', 'commercials')" class="dropdown-item" href="#" @click="removeAlert(row)">Excluir</a>
            </el-dropdown-menu>
          </el-dropdown>
        </el-table-column>
      </el-table>

      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        >
        </base-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import swal from "sweetalert2";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  Select,
  Option,
} from "element-ui";
export default {
  components: {
    [Table.name]: Table,
    [Option.name]: Option,
    [Select.name]: Select,
    [TableColumn.name]: TableColumn,
    flatPicker,
    PageTitle,
    Multiselect,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker
  },
  data() {
    return {
      filter: {},
      filtered: false,
      modals: {
        modal0: false,
        modal1: false,
      },
      isLoadingBrands: false,
      commercialsCopy: false,
      paginated_data: [],
      tables_erp: [],
      brands: [],
      table_erp: [],
      commercial: {
        commercial_table: [],
        copy: false,
      },
      commercialsCopy: [],
      item: "",
      commercials: [],
      commercialPeriod: [],
      isLoading: false,
      loadingSaveCommercial: false,
      errors: {},
      errorsBrands: {},
      suggestion: {},
      allSelected: false,
      config: {
        altInput: false,
        allowInput: true,
        dateFormat: "d/m/Y",
        locale: Portuguese,
      },
      commercialbrands: [],
      defaultTables: [],
      selectedTables: [],
      isLoadingDefaultTables: false
    };
  },
  async mounted() {
    this.getBrands();
    this.getCommercials();
    this.setData();
    await this.getTablesErp();
    await this.getDefaultErpTables();
    
  },
  methods: {
    toggleSelectAll() {
      if (this.allSelected) {
        this.commercialbrands= [];
      } else {
        this.commercialbrands = [...this.brands];
      }
      this.allSelected = !this.allSelected;
      this.errorsBrands.brands = null;
    },
    handleSelect() {
      this.allSelected = this.commercialbrands.length === this.brands.length;
    },
    limitText(count) { 
      return `+ ${count}`;
    },
    async getBrands(commercial_id) {
      try {
        this.isLoadingBrands = true;
        const response = await this.$http.secured.get("/api/v2/commercial_brands",{
          params: {
            q: {
              commercial_id: commercial_id,
            }
          },
        });
        this.brands = response.data.data;
        this.allSelected = this.commercialbrands.length === this.brands.length;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingBrands = false;
      }
    },
    async getCommercials() {
      try {
        const response = await this.$http.secured.get("/api/v1/commercials");
        this.commercialPeriod = response.data
      }catch (error){
        console.log(error)
      }
    },
    validationDayDisabledDate(time) {
      return time.getTime() < Date.parse(this.commercial.initial_date) || time.getTime() > Date.parse(this.commercial.final_date)
    },
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    setData(q, page) {
      this.isLoading = true;
      if (typeof page === "undefined") page = null;
      if (typeof q === "undefined" || this.emptyFilter) q = null;

      this.$http.secured
        .get("/api/v1/commercials", {
          params: {
            page: page,
            q: q,
          },
        })
        .then((response) => {
          this.commercials = response.data;

          for (let index = 0; index < this.commercials.length; index++) {
            if(this.commercials[index].initial_date) this.commercials[index].initial_date = new Date(`${this.commercials[index].initial_date}T00:00`)
            if(this.commercials[index].final_date)   this.commercials[index].final_date = new Date(`${this.commercials[index].final_date}T00:00`)
            if(this.commercials[index].alteration_limit)   this.commercials[index].alteration_limit = new Date(`${this.commercials[index].alteration_limit}T00:00`)
          }
          this.isLoading = false;

        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    search() {
      this.filtered = !this.emptyFilter
      this.setData(this.refactoredFilter)
      this.filter = {}
    },
    changePage(page) {
      let filterInput = null;
      if (this.filtered) filterInput = this.filter;
      this.setData(filterInput, page);
    },
    closeModal0(){
      this.errors = [];
      this.commercial = {};
      this.modals.modal0 = false;
    },
    closeModal1() {
      this.errors = [];
      this.commercial = {};
      this.modals.modal1 = false;
    },
    async getTablesErp() {
      this.isLoadingTables = true;
      try {
        const response = await this.$http.secured.get("/api/v1/table_erps")
        let tables = response.data;
        this.tables_erp = tables.sort((a, b) => a.desc_cta.localeCompare(b.desc_cta));
      } catch (error) {
        this.setError(error, "failed to fetch tables_erp");
      } finally {
        this.isLoadingTables = false;
      }
    },
    async getDefaultErpTables() {
      this.isLoadingDefaultTables = true;
      try {
        const response = await this.$http.secured.get("/api/v1/admin/settings")
        this.defaultTables = response.data.commercial_configurations.default_tables.value;
      } catch(error) { 
        console.log(error) 
      } finally {
        this.isLoadingDefaultTables = false;
      }
    },
    newCommercial(){
      this.modals.modal0 = true; 
      this.markDefaultTablesAsSelected(); 
      commercial = {};
    },
    edit(commercial) {
      this.commercial = Object.assign({}, commercial)
      this.commercial.commercial_table = commercial.commercial_table;
      this.modals.modal1 = true;
    },
    editcommercial() {
      if (!this.validateForm()) return;

      this.$http.secured
        .put(`/api/v1/commercials/${this.commercial.id}`, this.commercial)
        .then((response) => {
          this.response = response.data;
          this.modals.modal1 = false;
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.commercial = {};
        })
        .catch((error) => this.setError(error, "Cannot update commercial"));
    },
    formatCommercialBrand() {
      let tables = []

      if (!this.commercial.commercial_table) this.commercial.commercial_table = []

      this.commercial.commercial_table.map((commercial_table => {
        tables.push(this.tables_erp.filter((table => table.tabe_cta == commercial_table))[0])
      }))
      this.commercial.commercial_table = tables
    },
    formatedCommercialBrand() {
      this.commercial.copy_commercial_brands = this.commercialbrands.map(el => el.id )
    },
    async save() {
      const isFormValid = this.validateForm();
      const isBrandsValid = this.validateFormBrands();

      if (!isFormValid || !isBrandsValid) {
        return;
      }

      this.formatedCommercialBrand();
      this.formatCommercialBrand()
      
      this.loadingSaveCommercial = true;

      try {
        this.commercial.commercial_table = this.selectedTables;
        const response = await this.$http.secured.post("/api/v1/commercials", { commercial: this.commercial });
        this.commercials.push(response.data);
        this.$toasted.global.defaultSuccess();
        this.modals.modal0 = false;
        this.setData();
        this.commercial = {};
      } catch (error) {
        this.setError(error, "Cannot save commercial");
      } finally {
        this.loadingSaveCommercial = false;
      }
    },
    validateFormBrands() {
      this.errorsBrands = {};

      if (this.commercial.copy == true) {
        if (!this.commercialsCopy || this.commercialsCopy.length === 0) {
          this.errorsBrands.commercial = "Selecionar um Período Comercial é obrigatório.";
        }
        if (!this.commercialbrands || this.commercialbrands.length === 0) {
          this.errorsBrands.brands = "Selecione ao menos uma marca comercial.";
        }
      }

      return Object.keys(this.errorsBrands).length === 0;
    },
    validateForm() {
      let isValid = true;

      if (!this.commercial.name || this.commercial.name.length === 0) {
        this.$set(this.errors, 'name', 'Descrição do Período Comercial é obrigatório.');
        isValid = false;
      }

      if (!this.commercial.initial_date || !this.commercial.final_date) {
        this.$set(this.errors, 'initial_date', 'Data de Início é obrigatória.');
        this.$set(this.errors, 'final_date', 'Data de Fim é obrigatória.');
        isValid = false;
      }

      if (!this.commercial.alteration_limit) {
        this.$set(this.errors, 'alteration_limit', 'Data limite para alteração é obrigatório.');
        isValid = false;
      }

      return isValid;
    },
    reportAlert(callback){
      swal
        .fire({
          title: `Aviso!`,
          text: 'O relatório será enviado a todos os vendedores ao final do período de alteração',
          width: "300px",
          buttonsStyling: false,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          icon: 'info',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger ml-1',
        })
        .then((result) => {
          if (result.isConfirmed) {
            callback()
          }
        });
    },
    removeAlert(commercial) {
      swal
        .fire({
          title: `Deseja excluir período comercial? ` + commercial.name,
          text: 'As condições comerciais vinculadas a esse período comercial serão deletadas!',
          showCancelButton: true,
          confirmButtonColor: '#F5365C',
          cancelButtonColor: '#8898aa',
          confirmButtonText: 'Excluir',
          cancelButtonText: 'Voltar',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.remove(commercial)
          }
        });
    },
    remove(commercial) {
      this.$http.secured
        .delete(`/api/v1/commercials/${commercial.id}`, commercial)
        .then((response) => {
          this.$toasted.global.defaultSuccess();
          this.setData();
          this.commercials.splice(this.commercials.indexOf(this.commercial), 1);
        })
        .catch((error) => this.setError(error, "Cannot delete Duração do Período Comercial"));
    },
    formatDate(dateString){
      let dateParts = dateString.split('/');
      let finalString = '' + dateParts[1] + '-' + dateParts[0]
      if (dateParts.length > 2) finalString += '-' + dateParts[2]

      return finalString
    },
    limitText(count){
      return `+ ${count}`;
    },
  },
  watch: {
    'commercialsCopy'(newCommercial) {
      if (newCommercial && newCommercial.id) {
        this.getBrands(newCommercial.id);
      }
    },
  },
  computed: {
    markDefaultTablesAsSelected() {
      if (!this.defaultTables.length || !this.tables_erp.length) return; 

      this.selectedTables = this.tables_erp.filter(table =>this.defaultTables.includes(table.desc_cta));
    },
    isAllSelected() {
      return this.commercialbrands.length === this.brands.length && this.brands.length > 0;
    },
    noneSelected() {
      return this.commercialbrands.length === 0;
    },
    commercialDateRange: {
      get: function() {
        return [this.commercial.initial_date, this.commercial.final_date];
      },
      set: function(range) {
        this.commercial = Object.assign({}, this.commercial, {
          initial_date: range[0],
          final_date:   range[1],
        })
      },
    },
    emptyFilter: function() {
      for (var key in this.filter) {
        if (this.filter.hasOwnProperty(key) && this.filter[key] != "")
          return false;
      }
      return true;
    },
    refactoredFilter: function(){
      let filter = this.filter;

      for (var key in filter) {
        if (
          filter.hasOwnProperty(key) &&
          filter[key] != "" &&
          filter[key].match(/\d+(?:\/\d+)+/)
        ){
          filter[key] = this.formatDate(filter[key])
        }

        return filter;
      }
    }
  },
};
</script>
<style>
.el-date-range-picker{
  margin-left: -100px;
  width: 750px;
}
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}
.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
}
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
</style>